import consultoriasRouter from "./consultorias/router"
import expedienteConsultores from "./expediente-consultores/expedienteConsultoresRouter"
import consultoraRouter from './consultora/consultoraRouter';
import controlActividadesJefaturaRouter from './control-actividades-jefatura/indexRouter';
import crearEntregablesRrhhRouter from './crear-entregables-rrhh/indexRouter';
import gestionEntregableEmpleado from "./gestion-entregable-empleado/gestionRouter"
import perfil from "./perfil/perfilRouter"

import prorrogaEntregableRouter from './prorroga-entregable/indexRouter';

export default [
  {
    path: '/consultorias',
    name: 'consultorias',
    guard: '',
    component: () => import(/* webpackChunkName: "rolesList" */ './index.vue'),
  },

  ...consultoraRouter,
  ...consultoriasRouter,
  ...expedienteConsultores,
  ...gestionEntregableEmpleado,
  ...controlActividadesJefaturaRouter,
  ...crearEntregablesRrhhRouter,
  ...perfil,
  ...prorrogaEntregableRouter,
 
]
